import React from 'react';
import PopupLink from 'ati-ui-react/components/PopupLink';
import ReactTooltip from 'ati-ui-react/components/ReactTooltip';

import { IconButtonStyles, Image } from './IconButtonStyles';

function IconButton({ href, text, src, id }) {
  return (
    <IconButtonStyles>
      <PopupLink href={href}>
        <div data-for={id} data-tip>
          <Image src={src} />
        </div>
        {text && (
          <ReactTooltip data-tip aria-haspopup="true" effect="solid" id={id}>
            <span>{text}</span>
          </ReactTooltip>
        )}
      </PopupLink>
    </IconButtonStyles>
  );
}

export default IconButton;
